import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["stepKey"];
import { useDispatch } from 'react-redux';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Footer, BackButton } from 'signup-components/components/SidePanelLayout/SidePanelLayout';
import { goPrevStep } from '../../store/flow/action-creators';
import { useTracker } from '../../tracking/useTracker';
import { useCanGoBack } from '../../hooks/useCanGoBack';
import { useCurrentStep } from '../../hooks/useCurrentStep';
import { useIsStepDataValid } from '../../hooks/useIsStepDataValid';
import SidePanelCompanyDomainLoading from './SidePanelCompanyDomainLoading';
import { useAICompanyDomainSubmit } from '../../hooks/useAICompanyDomainSubmit';
import { useView } from '../useView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SidePanelCompanyDomainFooter = _ref => {
  let {
      stepKey
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const Tracker = useTracker();
  const dispatch = useDispatch();
  const {
    currentStep
  } = useCurrentStep();
  const dataSeleniumAttr = `${currentStep}_button`;
  const isStepDataValid = useIsStepDataValid(currentStep);
  const {
    canGoBack,
    completedStep
  } = useCanGoBack();
  const shouldShowBackButton = Boolean(canGoBack && completedStep);
  const {
    submit
  } = useView({
    stepKey
  });
  const {
    aiCompanyDomainSubmit,
    isAiCompanyDomainSubmitEnabled
  } = useAICompanyDomainSubmit({
    submit,
    isStepDataValid
  });
  const onBackLinkClick = event => {
    event.preventDefault();
    Tracker.backButton(currentStep, completedStep);
    dispatch(goPrevStep());
  };
  return /*#__PURE__*/_jsxs(Footer, {
    children: [shouldShowBackButton && /*#__PURE__*/_jsx(BackButton, {
      onClick: onBackLinkClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'button.back'
      })
    }), /*#__PURE__*/_jsx(SidePanelCompanyDomainLoading, {}), /*#__PURE__*/_jsx(LoadingButton, Object.assign({
      "data-selenium": dataSeleniumAttr,
      disabled: !isAiCompanyDomainSubmitEnabled,
      preventClicksOnLoading: true,
      size: "medium",
      type: "submit",
      use: "primary",
      onClick: aiCompanyDomainSubmit
    }, props, {
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'button.next'
        })
      })
    }))]
  });
};